import BaseService from '../BaseService';
import api from '../../services/api';
import { debounceAsync } from '../../utils/debounce';

class ProdutosEmUsoService extends BaseService {
    constructor() {
        super('/atendimentos/produtos-em-uso/');
    }

    listar(atendimentoId, ordenarPor = 'produto', ordem = 'asc') {
        return this.getAll({
            atendimento_id: atendimentoId,
            ordenar_por: ordenarPor,
            ordem,
        });
    }
}

const fetchProdutosDisponiveis = async (atendimentoId, inputValue = '') => {
    if (!atendimentoId) return [];

    try {
        const response = await api.get('/atendimentos/produtos-em-uso/disponiveis/', {
            params: {
                atendimento_id: atendimentoId,
                nome: inputValue,
            },
        });

        const produtos = Array.isArray(response.data) ? response.data : [];

        return produtos.map((produto) => ({
            value: produto.id,
            label: produto.nome,
            data: produto,
        }));
    } catch (error) {
        console.error('Erro ao carregar produtos em uso disponiveis:', error);
        return [];
    }
};

const produtosEmUsoService = new ProdutosEmUsoService();

produtosEmUsoService.loadProdutosDisponiveis = (atendimentoId) =>
    debounceAsync((inputValue) => fetchProdutosDisponiveis(atendimentoId, inputValue), 500);

export default produtosEmUsoService;
